<template>
    <div class="main-con el-main">
        <nav-breadcrumb :menu="[{label: '助贷清算汇总表'}]"/>

        <el-form :model="reportForm"  ref="reportForm" label-width="150px">
            <el-row :gutter="10" class="bg-purple xamhtrpg">
                <el-col :span="12">
                    <el-form-item label="资方：" prop="l__lenderId">
                        <el-select placeholder="请选择资方" v-model.trim="reportForm.l__lenderId" filterable>
                            <el-option :label="item.label" :value="item.value" v-for="(item,idx) in lenderOptions" :key="idx"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="渠道商：" prop="d__dealerId">
                        <el-select placeholder="请选择渠道商" v-model.trim="reportForm.d__dealerId" filterable>
                            <el-option :label="item.label" :value="item.value" v-for="(item,idx) in dealerOptions" :key="idx"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="应还款月：" prop="plan__repayDate" :rules="{required: true, message: '应还款月不能为空'}">
                        <el-date-picker
                            v-model="reportForm.plan__repayDate"
                            value-format="yyyy-MM-01 00:00:00"
                            type="month"
                            placeholder="选择日期">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="税差率：" prop="taxFactor" :rules="{required: true, message: '税差率不能为空'}">
                        <el-input v-model="reportForm.taxFactor" type="number" style="width: 35%"></el-input>%
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <div class="tr xzmt">
            <el-button type="primary" @click="onSubmit('reportForm')">导出</el-button>
        </div>
    </div>
</template>

<script>
    import xhr from '../../utils/xhr'
    import moment from 'moment'
    import Status2CN from "../../filters/Status2CN";
    import {xmlBuildQuery} from "../../filters/CommonActions";
    import {formatMoney} from "../../filters/CommonFilters";
    export default {
        name: "ThreeTierRebateList",
        data() {
            return {
                reportForm:{
                    l__lenderId:'',
                    plan__repayDate:'',
                    taxFactor:0,
                    d__dealerId:''
                },
                lenderOptions:[],
                dealerOptions:[]
            }
        },
        computed : {
            filterParams: {
                get: function() {
                    return {
                        /*  pageSize: this.pageSize,
                          pageOffset: (this.page - 1) * this.pageSize,*/
                        // 'xlist.sort.dataField': 'fi.transactionDate',
                        // 'xlist.sort.order': 'desc'
                    }
                },
                set:function (newVal) {

                }
            }
        },
        watch: {
            filterParams: function () {
                //this.getReportingFinanceList()
            }
        },
        mounted() {
            // this.getReportingFinanceList()
            this.getLenderList()
            this.getDealerList()
        },
        methods: {
            /*getReportingFinanceList: function () {
                xhr.getFangReportingFinanceList(
                    Object.assign({pageSize:0}, {}, xmlBuildQuery(this.filters)),
                    res=> {
                        try {
                            this.listData = res.data
                        }catch(e){

                        }
                    })

            },*/
            getDealerList: function () {
                xhr.getDealerList(
                    Object.assign({
                        'xlist.search.d.forLender':'Y',
                        'xlist.search.d.forLender.op':'eq',
                        pageSize:0}, this.filterParams, {}),
                    res=> {
                        try {
                            this.dealerOptions = res.data.data.map(item=>{
                                return {
                                    label: item.d__dealerName,
                                    value:item.d__dealerId,
                                }
                            })
                        }catch(e){

                        }
                    })

            },
            getLenderList: function () {
                xhr.getLenderList(
                    Object.assign({pageSize:0}, this.filterParams, {}),
                    res=> {
                        try {
                            this.lenderOptions = res.data.data.map(item=>{
                                return {
                                    label: item.d__lenderName,
                                    value:item.d__lenderId,
                                }
                            })
                        }catch(e){

                        }
                    })

            },
            onSubmit:function (formName) {
                this.$refs[formName].validate(valid=> {
                    if (valid) {
                        if(this.reportForm.taxFactor>=0&&this.reportForm.taxFactor<=100){
                            let routeData = this.$router.resolve({
                                path: '/ix/fang/financing/lender/reporting/ThreeTierRebate.List?format=xls',
                                query: Object.assign({}, this.filterParams, {
                                    'xlist.search.l.lenderId':this.reportForm.l__lenderId,
                                    'xlist.search.l.lenderId.op':'eq',
                                    'xlist.search.d.dealerId':this.reportForm.d__dealerId,
                                    'xlist.search.d.dealerId.op':'eq',
                                    'xlist.search.plan.repayDate':this.reportForm.plan__repayDate,
                                    'xlist.search.plan.repayDate.op':'gteq',
                                    'taxFactor':this.reportForm.taxFactor,
                                })
                            });
                          /*  console.log(routeData)
                            console.log(this.reportForm.plan__repayDate)*/
                            window.open(routeData.href.replace('#/', '/'), '_blank');
                        }else{
                            alert("税率差要大于等于0小于等于100")
                        }

                    }
                })
            },
            onClose:function () {
                this.dialogVisible = false
                this.reportForm.taxFactor = 0
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/ThreeTierRebateList.vue